/**
 * Fichier genere automatiquement — NE PAS MODIFIER MANUELLEMENT
 * Executez "npm run extract:permissions" pour le mettre a jour.
 */

export interface ExtractedPermissionFeature {
      key: string;
      fileName: string;
      featureName: string;
      rawValue: string;
      containsDynamic: boolean;
      resolvedPermissions?: string[];
      locations: { file: string; line: number }[];
}

export const All_Permission_Features: ExtractedPermissionFeature[] = [
  {
      key: 'role-list.name="role-alert-message"-class="w-full',
      fileName: 'role-list',
      featureName: 'name="role-alert-message"-class="w-full',
      rawValue: "['role-alert-message']",  
      containsDynamic: false,
  // Aucune permission resolvable
      locations: [
      { file: 'src/app/components/matwins-tenant/role/role-list/role-list.component.html', line: 4 }
  ]
  }
];

export const All_Feature_Keys = All_Permission_Features.map(f => f.key);

export const All_ExclusiveFeature_Keys = All_Permission_Features.filter(item =>
  item.resolvedPermissions?.every(permission =>!permission.startsWith('Permissions.Entities'))).map(f => f.key);
